export default "__VITE_ASSET__Cn7fn0tm__"